import { render, staticRenderFns } from "./AllContactList.vue?vue&type=template&id=20324e80&"
import script from "./AllContactList.vue?vue&type=script&lang=js&"
export * from "./AllContactList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports